import { render, staticRenderFns } from "./AddWorkstationModal.vue?vue&type=template&id=c4c91b46"
import script from "./AddWorkstationModal.vue?vue&type=script&lang=js"
export * from "./AddWorkstationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports